import React, { useEffect, useRef, useState } from 'react';
import { useContext } from 'react';
import quizInstanceStatusContext from '../context/quizInstanceStatusContext'

export default function QuizWaitingRoom() {

  const ctx = useContext(quizInstanceStatusContext);
	const [counter, setCounter] = useState(null);
  const [muted, setMuted] = useState(false);
  const audioRef = useRef(null);

  const lobbyMusic = ctx.quizInfo?.config?.lobbyMusic;
  const proxyUrl = lobbyMusic?.previewUrl
    ? `/api/deezer/preview?url=${encodeURIComponent(lobbyMusic.previewUrl)}`
    : null;

  // Start immediately on mount — user gesture (join click) is still fresh here.
  // Waiting for counter state update loses the autoplay window.
  useEffect(() => {
    if (!proxyUrl) return;
    const audio = new Audio(proxyUrl);
    audio.loop = true;
    audioRef.current = audio;
    audio.play().catch(() => {});
    return () => {
      audio.pause();
      audio.src = '';
      audioRef.current = null;
    };
  }, [proxyUrl]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.muted = muted;
    }
  }, [muted]);

	useEffect(() => {
		const eventName = "quizParticipantCounterUpdate";
		const eventHandler = msg => { setCounter(msg.counter || 0); };
		ctx.socket.on(eventName, eventHandler);
		return () => { ctx.socket.off(eventName, eventHandler); };
	}, [ctx]);

	return (
		<div id="quizWaitingRoom">
			{counter === null ? "" :
				<div className="d-flex justify-content-center align-items-center h-100">
					<div className="text-center">
						<h3>Det börjar strax ...</h3>
						<p>{counter} person{counter > 1 ? "er" : ""} väntar på att quizzen ska starta ...</p>
						{ctx.quizInfo.waitingRoomMediaId &&
							<img
								src={`/api/media/${ctx.quizInfo.waitingRoomMediaId}`}
								style={{ width: "200px", borderRadius: "5px"}}
								alt=""
							/>
						}
            {proxyUrl && lobbyMusic && (
              <div className="mt-3 d-flex flex-column align-items-center" style={{ gap: "8px" }}>
                {lobbyMusic.cover && (
                  <img src={lobbyMusic.cover} alt="" style={{ width: "64px", height: "64px", borderRadius: "6px", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }} />
                )}
                <div style={{ fontSize: "13px", color: "#555" }}>
                  <strong>{lobbyMusic.title}</strong> — {lobbyMusic.artist}
                </div>
                <button
                  onClick={() => setMuted(m => !m)}
                  style={{
                    background: "none",
                    border: "1px solid #ccc",
                    borderRadius: "20px",
                    padding: "4px 16px",
                    cursor: "pointer",
                    fontSize: "13px",
                    color: "#555"
                  }}>
                  {muted ? "Sätt på ljud" : "Stäng av ljud"}
                </button>
              </div>
            )}
					</div>
				</div>
			}
		</div>
	);

}
